import { z } from 'zod';

export const buttonStyleSchema = z.enum(['LINK', 'PRIMARY']);

export const ButtonStyle = buttonStyleSchema.enum;

export type ButtonStyle = z.infer<typeof buttonStyleSchema>;
